import _ from 'lodash'
const state = {
  data: {
    mostrar: false,
    yt_id: null,
    vars: {
      autoplay: 1
    }
  },
  videos: []
}

const getters = {
  data: state => {
    return state.data
  },
  videos: state => {
    return state.videos
  },
  videosPorGrupo: state => grupo => {
    return _.filter(state.videos, item => {
      return item.grupo === grupo
    })
  }
}

const actions = {
  mostrar (context, payload) {
    context.commit('mostrar', payload)
  },
  cerrar (context) {
    context.commit('cerrar')
  },
  setVideos (context, payload) {
    context.commit('setVideos', payload)
  }
}

const mutations = {
  mostrar (state, payload) {
    state.data = _.assign({
      yt_id: null,
      vars: { autoload: 1 },
      titulo: '',
      mostrar: true
    }, payload)
  },
  cerrar (state) {
    state.data = _.assign({
      yt_id: null,
      vars: { autoload: 1 },
      titulo: '',
      mostrar: false
    })
  },
  setVideos (state, payload) {
    state.videos = payload.videos_ayuda
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
